import { ReactNode } from "react";

import { FormConfig } from "@evergiving/common/dist/es2015/form";
import { DevActions } from "@/lib/components/DevActions";
import { BackgroundImage } from "@/lib/build/BackgroundImage";

export function PageContainer({
  children,
  formConfig,
}: {
  formConfig: FormConfig;
  children: ReactNode;
}) {
  return (
    <div className="page">
      <DevActions />
      <BackgroundImage formConfig={formConfig} />
      <div className="scrollContainer">{children}</div>
    </div>
  );
}
